import {
  zodToOpenaiJsonSchema
} from "./chunk-FQFJR6TD.mjs";

// types/agents/agents.ts
import { z } from "zod";
var AgentToAgentActionSchema = z.object({
  id: z.string().uuid().describe("Unique identifier for the agent action"),
  target_agent_id: z.string().uuid().describe("ID of the agent to interact with"),
  type: z.string().describe("Type of agent-to-agent interaction")
});
var AgentWorkflowSchema = z.object({
  name: z.string().min(1).max(100).describe("Display name of the workflow"),
  description: z.string().max(500).optional().describe("Optional description of what this workflow does"),
  enabled: z.literal(false).describe(
    "Whether this workflow is currently active (always false for new workflows)"
  ),
  instructions: z.string().max(1e4).optional().describe("Specific instructions for this workflow"),
  type: z.literal("TRIGGER")
});
var TemplateAgentSchema = z.object({
  id: z.string().regex(/^_AGENT_\d+$/).describe("Template placeholder ID for this agent (e.g., _AGENT_1)"),
  name: z.union([
    z.string().min(1).max(100).regex(/\$\{\{ *([A-Za-z0-9_.]+) *\}\}/),
    z.string().min(1).max(100)
  ]).describe("Display name of the agent (supports template placeholders)"),
  description: z.union([
    z.string().max(500).regex(/\$\{\{ *([A-Za-z0-9_.]+) *\}\}/),
    z.string().max(500)
  ]).optional().describe(
    "Optional description of the agent's purpose (supports template placeholders)"
  ),
  workflow: AgentWorkflowSchema.describe(
    "The workflow configuration for this agent"
  )
});
var AgentSchema = z.object({
  id: z.string().uuid().describe("Unique identifier for the agent"),
  name: z.string().min(1).max(100).describe("Display name of the agent"),
  description: z.string().max(500).optional().describe("Optional description of the agent's purpose"),
  workflow: AgentWorkflowSchema.describe(
    "The workflow configuration for this agent"
  )
});
var agentOpenAiJsonSchema = zodToOpenaiJsonSchema(
  TemplateAgentSchema,
  "agents",
  {}
);

export {
  AgentToAgentActionSchema,
  AgentWorkflowSchema,
  TemplateAgentSchema,
  AgentSchema,
  agentOpenAiJsonSchema
};
